import { IconRefresh, IconSearch } from "@teral/icons";

type SearchIconProps = {
  isProcessing: boolean;
};

export const SearchIcon = ({ isProcessing }: SearchIconProps) => {
  if (isProcessing) {
    return <IconRefresh className="text-gray-10 size-4 animate-spin" data-testid="loading-icon" />;
  }

  return <IconSearch className="text-gray-9 size-4" data-testid="search-icon" />;
};
